<template>
  <el-dialog :visible.sync="visible" :maskClosable="false" append-to-body @cancel="hideModal"
    :width="dialogWidth + 18.5 + 'mm'" top="20px">
    <el-spin :spinning="spinning" style="min-height: 100px">
      <div id="printBox" :style="`height:${isEdit ? 0 : height
        }mm ;width:${width}mm;overflow:hidden;margin: auto;`">
        <div :id="'preview_content_design' + randomString"
          :style="`height:${height}mm ;overflow-y: scroll;overflow-x:hidden;`"></div>
      </div>
    </el-spin>
    <rich-editor ref="rich" :height="heightPx" v-if="isEdit" v-model="htmlStr"></rich-editor>
    <template slot="title">
      <el-space>
        <div class="margin-bottom-xs text-lg text-bold">{{ title }}</div>
        <el-button size="small" :loading="waitShowPrinter" type="primary" icon="printer" @click.stop="edit"> {{ isEdit ?
          "预览" : "编辑" }}</el-button>
        <el-button size="small" :loading="waitShowPrinter" type="primary" icon="printer"
          @click.stop="print">打印</el-button>
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content">
            普通打印错误时，尝试兼容打印。需要下载兼容打印
            <a style="color: aqua"
              href="https://src.qingguangtech.com/application/1660481339712864319/qingguang/attachment/c1ff4dea6fc64a0199a4a83334b6f8dc.exe">Clodop_for_Win32NT</a>
          </div>
          <el-button size="small" :loading="waitShowPrinter" type="primary" icon="printer"
            @click.stop="printPreview(1)">兼容打印</el-button>
        </el-tooltip>
        <el-button size="small" :loading="waitShowPrinter" type="primary" icon="printer"
          @click.stop="exportHtmlToWord()">导出表格</el-button>
        <el-button size="small" type="primary" icon="printer" @click.stop="toPdf">pdf</el-button>
      </el-space>
      <br />
      <el-space v-if="printData && printData.length != 1">
        <el-button style="margin-top: 10px" :key="id" :type="id == index ? 'success' : ''" v-for="(it, id) in printData"
          size="mini" @click="tochange(id)">
          第{{ id + 1 }}份</el-button>
      </el-space>
    </template>
  </el-dialog>
</template>
<script>
// import htmlToDocx from 'html-to-docx'
// import * as htmlDocx from 'html-docx-js';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { getLodop } from '@/utils/cLodopPrint';
import html2canvas from 'html2canvas';
import { sysPrintHistoryContent_add, sysPrint_htmlToWord } from '@/api/myController/system';
import { generateRandomString, getToken, setToken, getAppId } from '@/utils';
import projectConfig from '@/core/config';
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
let LODOP;
export default {
  name: 'printPreview',
  props: {
    title: {
      type: String,
      required: false,
      default: '打印预览'
    },
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    printModule: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      htmlToWordUrl: projectConfig.baseUrl + 'qingguang/tenantbussiness/sysPrint/htmlToWord', // 上传图片路径
      spinning: true,
      waitShowPrinter: false,
      index: 0,
      isEdit: false,
      // 纸张宽 mm
      width: 0,
      dialogWidth: 0,
      dH: 0,
      // 模板
      hiprintTemplate: {},
      printContentDetails: '',
      htmlStr: '',
      heightPx: 300,
      widthPx: 150,
      // 数据
      printData: [],
      randomString: ''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.randomString = generateRandomString();
  },
  mounted() { },
  methods: {
    edit() {
      var that = this;
      var data = that.$refs.rich?.getHtml();
      this.isEdit = !this.isEdit;
      this.$nextTick(() => {
        if (!this.isEdit) {
          if (data) $('#preview_content_design' + this.randomString).html(data);
        } else {
          this.htmlStr = $('#preview_content_design' + this.randomString).html();
        }
      });
    },
    showHt(thStr, paperWidth, paperHeight) {
      this.visible = true;
      this.width = Number(paperWidth);
      this.dialogWidth = this.width > 210 ? this.width : 210;
      this.height = Number(paperHeight);
      setTimeout(() => {
        this.heightPx = $('#preview_content_design' + this.randomString).height();
        this.isEdit = true;
      }, 10);
      this.htmlStr = thStr;
    },
    hideModal() {
      this.visible = false;
    },
    show(hiprintTemplate, printData, width = '210') {
      console.log(printData);
      var str = '加载中';
      var loadingDiv = `<div class="padding-lg text-center text-xl text-bold">${str}</div>`;
      $('#preview_content_design' + this.randomString).html(loadingDiv);
      console.log('hiprintTemplate', hiprintTemplate);
      this.printContentDetails = JSON.stringify(printData);
      printData = printData || [];
      if (hiprintTemplate == null) {
        this.$message.warning('未选择打印模板');
        return;
      }
      if (printData.length == 0) {
        this.$message.warning('未选择数据');
        return;
      }
      this.visible = true;
      this.spinning = true;
      this.width = hiprintTemplate?.printPanels[0].width;
      this.height = hiprintTemplate?.printPanels[0].height;
      this.dialogWidth = this.width > 210 ? this.width : 210;
      console.log('this.dialogWidth', this.dialogWidth)
      this.hiprintTemplate = hiprintTemplate;
      this.printData = printData;
      setTimeout(() => {
        this.$nextTick(() => {
          this.heightPx = $('#printBox').height();
          this.widthPx = $('#printBox').width();
        });
        // eslint-disable-next-line no-undef
        $('#preview_content_design' + this.randomString).html('');
        printData.forEach((it, index) => {
          console.log(it, index)
          var div = hiprintTemplate
            .getHtml(printData[index])
            .css({ border: '1px solid #aaa' });
          $('#preview_content_design' + this.randomString).append(div);
        });
        this.spinning = false;
      }, 500);
    },
    tochange(id) {
      this.index = id;
      var h = $(`#preview_content_design${this.randomString} > div`).height();
      var hs = h * id + id * 2;
      $('#preview_content_design' + this.randomString).scrollTop(hs);
    },
    print(e) {
      if (this.isEdit) {
        var data = this.$refs.rich?.getHtml();
        if (data) $('#preview_content_design' + this.randomString).html(data);
      }
      this.isEdit = false;
      this.waitShowPrinter = true;
      const element = document.getElementById(
        'preview_content_design' + this.randomString
      );
      var hs = element.style.height;
      element.style.height = 'auto';
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        children[i].style.border = 'none';
      }
      var h = element.innerHTML;

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      // 将富文本内容插入到iframe中
      document.body.appendChild(iframe);
      const iframeWindow = iframe.contentWindow;
      const iframeDocument = iframeWindow.document;
      iframeDocument.open();
      var ht = `
    <html>
      <head>
  <link rel='stylesheet' href='./style/print-lock.css?v=1.752' />
  <link rel='stylesheet' media="print" href='./style/print-lock.css?v=1.752' />    
      </head>
      <body>${h}</body>
    </html>
  `;
      if (e == 1) {
        ht = ht.replace(
          '<body>',
          '<body><style>.hiprint-printTemplate { transform: rotate(90deg); transform-origin: 49%; }</style>'
        );
      }
      iframeDocument.write(ht);
      if (e == 1) {
        var styleTag = iframeDocument.getElementsByTagName('style')[0];
        var currentStyle = styleTag.innerHTML;

        // 使用正则表达式匹配size属性并提取当前的宽度和高度
        var sizeMatch = currentStyle.match(
          /size:\s*(\d+(\.\d+)?[a-z]+)\s*(\d+(\.\d+)?[a-z]+)/
        );
        if (sizeMatch) {
          var width = sizeMatch[1];
          var height = sizeMatch[3];
          // iframeDocument.body.style.width = height
          // iframeDocument.body.style.height = width
          // iframeDocument.body.style.overflowX = "hidden"
          // 创建新的size属性值，宽度和高度互换
          var newSize = `size: ${height} ${width}`;
          console.log(newSize);
          // 替换当前<style>标签中的size属性
          var newStyle = currentStyle.replace(
            /size:\s*\d+(\.\d+)?[a-z]+\s*\d+(\.\d+)?[a-z]+/,
            newSize
          );
          // 更新<style>标签的内容
          styleTag.innerHTML = newStyle;
        }
      }
      iframeDocument.close();
      if (this.modules > 0 && this.printModule.sysPrintId) {
        sysPrintHistoryContent_add({
          sysPrintHistoryContentDto: {
            modules: this.modules,
            printContentDetails: h,
            other1: this.width,
            other2: this.height,
            sysPrintId: this.printModule.sysPrintId,
            sysPrintName: this.printModule.sysPrintName,
            sysPrintType: this.printModule.sysPrintType
          }
        }).then((res) => { });
      }
      setTimeout(() => {
        iframeWindow.print();
        element.style.height = hs;
        for (let i = 0; i < children.length; i++) {
          children[i].style.border = '1px solid rgb(170, 170, 170)';
        }
        setTimeout(() => {
          document.body.removeChild(iframe);
          this.waitShowPrinter = false;
        }, 50); // 等待打印完成后再移除iframe
      }, 1000);
    },

    printPreview(s) {
      this.CreateOneFormPage();
      if (s == 0) {
        LODOP.PRINT(); // 直接打印
      }
      if (s == 1) {
        LODOP.PREVIEW(); // 打印预览
      }
      if (s == 2) {
        LODOP.PRINT_SETUP(); // 打印维护
      }
      if (s == 3) {
        LODOP.PRINT_DESIGN(); // 打印设计
      }
    },
    CreateOneFormPage() {
      LODOP = getLodop();
      console.log(this.width, this.height);
      if (this.isEdit) {
        var data = this.$refs.rich?.getHtml();
        if (data) $('#preview_content_design' + this.randomString).html(data);
      }
      this.isEdit = false;
      this.waitShowPrinter = true;
      const element = document.getElementById(
        'preview_content_design' + this.randomString
      );
      var hs = element.style.height;
      element.style.height = 'auto';
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        children[i].style.border = 'none';
      }
      var h = element.innerHTML;

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      // 将富文本内容插入到iframe中
      document.body.appendChild(iframe);
      const iframeWindow = iframe.contentWindow;
      const iframeDocument = iframeWindow.document;
      iframeDocument.open();
      var ht = `
  <link rel='stylesheet' href='./style/print-lock.css?v=1.7521' />
  <link rel='stylesheet' media="print" href='./style/print-lock.css?v=1.7521' />    ${h}
  `;
      LODOP.PRINT_INIT('订单'); // 打印初始化
      LODOP.SET_PRINT_PAGESIZE(1, 100000, 100000, ''); // 设定纸张大小
      LODOP.SET_PREVIEW_WINDOW(2, 2, 0, 0, 0, ''); // 设置窗口
      LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', ht); // 增加超文本项
      this.waitShowPrinter = false;
    },
    exportHtmlToWord() {
      this.isEdit = false;
      this.waitShowPrinter = true;
      const element = document.getElementById(
        'preview_content_design' + this.randomString
      );
      var hs = element.style.height;
      element.style.height = 'auto';
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        children[i].style.border = 'none';
      }
      var h = element.innerHTML;
      var ht = `<html>
      <head> 
      </head>
      <body>${h}</body>
    </html>
  `;

      const regex = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi;
      ht = ht.replace(regex, '');
      const config = {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': getToken()
        }
      };

      axios.post(this.htmlToWordUrl, { html: ht }, config)
        .then(response => {
          // 检查响应状态码
          if (response.status === 200) {
            console.log('response', response.data.size)
            const arrayBuffer = response.data;
            const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            // 根据你的文件类型设置 MIME 类型
            const url = URL.createObjectURL(blob);

            // 创建一个 <a> 元素并触发下载
            const a = document.createElement('a');
            a.href = url;
            a.download = 'filename.docx'; // 设置下载的文件名
            document.body.appendChild(a);
            a.click();

            // 清理
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            this.waitShowPrinter = false;
          } else {
            this.waitShowPrinter = false;
            console.error('Response status was not 200:', response.status);
          }
        })
        .catch(error => {
          this.waitShowPrinter = false;
          console.error('There was an error!', error);
        });

      return

      const htmlContent = document.getElementById('preview_content_design' + this.randomString).innerHTML;
      const result = htmlContent.replace(regex, '');
      // 使用 replace 方法将匹配到的内容替换为空字符串

      htmlToDocx(result).then((data) => {
        saveAs(data, 'output.docx');// 下载文件
        // data就是转出的文件
      })
    },
    exportTableToExcel() {
      // 获取表格DOM元素
      const table = document.getElementById('preview_content_design' + this.randomString);

      // 将HTML表格转换为工作表，同时尝试保留样式（这是一个简化的例子）
      const worksheet = XLSX.utils.table_to_sheet(table, { defval: '' });

      // 由于HTML和Excel的样式不完全兼容，我们需要手动设置一些样式
      // 这里是一个简化的例子，只设置了边框和填充色
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cell_address]) continue;

          // 设置边框（这里只设置了最简单的边框样式）
          worksheet[cell_address].s = {
            border: {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' }
            }
          };

          // 尝试设置填充色（注意：Excel的填充色与HTML的background-color不完全对应）
          // 这里我们根据HTML表格的样式来设置，但可能无法完美匹配
          const cell = table.rows[R - 1].cells[C - 1];
          const computedStyle = window.getComputedStyle(cell);
          const bgColor = computedStyle.backgroundColor;
          if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
            // 注意：这里使用了XLSX的填充色代码，你可能需要查找或创建一个映射来将HTML颜色转换为Excel颜色
            // 这里只是一个简化的例子，实际使用时可能需要更复杂的处理
            worksheet[cell_address].s.fill = {
              fgColor: {
                rgb: bgColor.replace(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/, function (match, r, g, b) {
                  // 将RGB转换为十六进制格式（注意：这里可能不是完全正确的转换方式，因为Excel使用的是ARGB格式）
                  return `FF${('0' + parseInt(r).toString(16)).slice(-2)}${('0' + parseInt(g).toString(16)).slice(-2)}${('0' + parseInt(b).toString(16)).slice(-2)}`;
                })
              }
            };
          }

          // 你可以在这里添加更多样式转换逻辑，比如字体、字体大小、字体颜色等
        }
      }

      // 创建一个新的工作簿并将工作表添加到其中
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // 将工作簿写入二进制字符串，并保存为Excel文件
      const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
      const buffer = new ArrayBuffer(excelData.length);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < excelData.length; i++) {
        view[i] = excelData.charCodeAt(i) & 0xFF;
      }
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'table_with_styles.xlsx');
    },
    async toPdf() {
      this.isEdit = false;
      var p = 'p';
      if (this.width > this.height) p = 'l';
      const s = new jsPDF(p, 'mm', [this.width, this.height]);
      const element = document.getElementById(
        'preview_content_design' + this.randomString
      );
      var hs = element.style.height;
      element.style.height = 'auto';
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        children[i].style.border = 'none';
      }
      setTimeout(async () => {
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true
        });
        element.style.height = hs;
        for (let i = 0; i < children.length; i++) {
          children[i].style.border = '1px solid rgb(170, 170, 170)';
        }
        const pdfWidth = s.internal.pageSize.getWidth();
        const pdfHeight = s.internal.pageSize.getHeight();
        const ctx = canvas.getContext('2d');
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        const imageData = canvas.toDataURL('image/jpeg');
        const pageHeight = pdfHeight;
        const a = pdfWidth / canvas.width;
        const contentWidth = pdfWidth;
        const contentHeight = canvas.height * a;

        var d = $('#preview_content_design' + this.randomString).find(
          '.hiprint-printPanel .hiprint-printPaper'
        ).length; // 页数
        for (var k = 0; k < d; k++) {
          s.addImage(
            imageData,
            'JPEG',
            0,
            -k * pageHeight + 1.1 * k,
            contentWidth,
            contentHeight
          );
          if (k < d - 1) {
            s.addPage();
          }
        }
        setTimeout(() => {
          const pdfBlob = s.output('blob');
          // 创建下载链接
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(pdfBlob);
          downloadLink.download = this.printData[0].companyName + '打印.pdf';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }, 50);
      }, 2);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .hiprint-printElement-tableTarget td {
  height: 18pt;
}

/deep/ .w-e-text table {
  margin: auto;
}

/deep/ .w-e-text table td {
  border-color: #333;
}

/deep/ .ant-modal-body {
  padding: 0px;
}

::v-deep .el-dialog__body {
  padding-top: 0;
}

/deep/ .ant-modal-content {
  margin-bottom: 24px;
}
</style>
